export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;
export const AI_ENDPOINT = import.meta.env.VITE_AI_ENDPOINT;
export const CHAT_ENDPOINT = import.meta.env.VITE_CHAT_ENDPOINT;
export const ADMIN_ENDPOINT = import.meta.env.VITE_ADMIN_ENDPOINT;
export const PROMPT_ENDPOINT = import.meta.env.VITE_PROMPT_ENDPOINT;
export const WEBHOOK_ENDPOINT = import.meta.env.VITE_WEBHOOK_ENDPOINT;
export const ARTILLERY_ENDPOINT = import.meta.env.VITE_ARTILLERY_ENDPOINT;
export const GPT_WSS = import.meta.env.VITE_GPT_WSS;
export const WSS_ENCRYPTION_KEY = import.meta.env.VITE_WSS_ENCRYPTION_KEY;
export const SENTRY_AUTH_TOKEN = import.meta.env.VITE_SENTRY_AUTH_TOKEN;
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
export const COGNITO_USER_POOL_ID = import.meta.env.VITE_COGNITO_USER_POOL_ID;
export const COGNITO_REGION = import.meta.env.VITE_COGNITO_REGION;
export const COGNITO_APP_CLIENT_ID = import.meta.env.VITE_COGNITO_APP_CLIENT_ID;
export const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN;
export const COGNITO_REDIRECT_URI = import.meta.env.VITE_COGNITO_REDIRECT_URI;
export const JIRA_DOMAIN = import.meta.env.VITE_JIRA_DOMAIN;
